import { getDate } from "../../../../utils/utils"
import WorkflowFile from "../../components/WorkflowFile/WorkflowFile"
import { AllWorkflowsSectionProps } from "./AllWorkflowsSection.types"
import AddToGroupAlert from "../../components/AddToGroupAlert/AddToGroupAlert"
import ConfirmationAlert from "../../../../components/ConfirmationAlert/ConfirmationAlert"
import useMoveFile from "../../../../hooks/useMoveFile"
import "./AllWorkflowsSection.css"

const AllWorkflowsSection = (props: AllWorkflowsSectionProps) => {

  const { 
    workflows,
    showMoveWorkflow,
    error,
    selectedWorkflow,
    showConfirmDelete,
    onShowDeleteConfirmation,
    onSelectWorkflow,
    onHideMoveWorkflow,
    onOpenWorkflow,
    onShowMoveWorkflow,
    onDeleteWorkflow,
    onError
  } = props

  const [{
    groups,
    selectedGroup,
    parentGroups,
    onLoadSubGroups,
    onSelectGroup,
    onMoveWorkflow
  }] = useMoveFile({
    onMove: onHideMoveWorkflow,
    workflowId: selectedWorkflow?.id,
    onError: onError
  })

  return (
    <div className="all-workflows-container">
      {workflows.length > 0 && (
        <div className="all-workflows-header-container">
          <p className="workflows-result-header">PIPE ID</p>
          <p className="workflows-result-header">ASSET TEMPERATURE</p>
          <p className="workflows-result-header">DATE</p>
          <p className="workflows-result-header">WORKFLOW ANOMALIES</p>
          <p className="workflows-result-header"></p>
        </div>
      )}
      {workflows.length === 0 && error === undefined && (
        <div className="no-results-container">
          <p>No saved workflows.</p>
        </div>
      )}

      {workflows.length === 0 && error !== undefined && (
        <div className="no-results-container">
          <p>{`Failed to fetch workflows: ${error.message}`}</p>
        </div>
      )}
      {workflows.map((workflow) => (
          <WorkflowFile
            key={workflow.id}
            isSelected={selectedWorkflow?.id === workflow.id}
            onSelect={() => onSelectWorkflow(workflow)}
            onClick={() => onOpenWorkflow(workflow)}
            pipeId={workflow.pipe_id}
            temperature={`${workflow.pipe_temp}`}
            date={getDate(workflow.date)}
            anomalies={"-"}
            enabled={workflow.is_fully_uploaded}
            ellipsisMenu={[
              {
              item: "Open",
              onClick: () => onOpenWorkflow(workflow)
              },
              {
              item: "Move",
              onClick: () => onShowMoveWorkflow(workflow)
              },
              {
              item: "Delete",
              onClick: () => onShowDeleteConfirmation(true)
              }
            ]}
          />
      ))}

      <ConfirmationAlert
        show={showConfirmDelete}
        title="Delete Workflow"
        subtitle="Are you sure you want to delete this workflow. Once deleted it cannot be undone."
        onConfirmText="Delete"
        onConfirm={onDeleteWorkflow}
        onCancel={() => onShowDeleteConfirmation(false)}
      />

      <AddToGroupAlert 
        show={showMoveWorkflow}
        parentGroups={parentGroups}
        onHide={onHideMoveWorkflow} 
        onMove={onMoveWorkflow}
        groups={groups}
        selectedGroup={selectedGroup}
        onSelectGroup={onSelectGroup}
        onLoadGroups={onLoadSubGroups}
      />
    </div>
  )
}

export default AllWorkflowsSection